define('redactor/src/view/redactor.view',['require','exports','module','underscore','uikit/uikit','../behavior/horizontally.scrollable.behavior','jquery','../redactor.patched','../limiter.module'],function(require, exports, module){
  var _                              = require('underscore');
  var UIKit                          = require('uikit/uikit');
  var HorizontallyScrollableBehavior = require('../behavior/horizontally.scrollable.behavior');
  var jQuery                         = require('jquery');
                                       require('../redactor.patched');
                                       require('../limiter.module');


  var RedactorView = UIKit.ItemView.extend({

    constructor : function ( attributes, options ) {
      // need to make sure behaviors defined here are not overwritten
      this.behaviors = _.extend(_.result(this, 'behaviors'), _.result(this, 'baseBehaviors'));

      UIKit.ItemView.apply( this, arguments );
    },

    template: function(options) {
      if (options.headerTag) {
        return '<' + options.headerTag + '></' + options.headerTag + '>';
      } else {
        return '<textarea />'
      }
    },

    options: {
      air: false,
      basic: false,
      borderless: false,
      buttons: ['format', 'bold', 'italic', 'underline', 'deleted', 'lists', 'link'],
      disabled: false,
      fitted: false,
      focus: false,
      headerTag: null,
      // and text is scrolled all the way to the left and on focus, ellipsis goes away
      // and user can scroll all the way to the right.
      // number of characters to limit input by
      horizontallyScrollable: false,
      // when true, scrolling will be handled, so that on blur ellipsis is shown
      limiter: null,
      minHeight: false,
      placeholder: '',
      pluginOptions: null,
      plugins: [],
      readonly: false,
      tabindex: "0",
      tabKey: false,
      value: ''
    },

    events: {
      'keydown': function(ev) {
        if (this.readonly || this.disabled) {
          ev.stopImmediatePropagation();
          ev.preventDefault();
          return false;
        }
      }
    },

    ui: function() {
      return {
        'textarea': (this.getOption('headerTag') ? this.getOption('headerTag') : 'textarea')
      }
    },

    baseBehaviors: function() {
      return {
        HorizontallyScrollableBehavior: {
          behaviorClass: HorizontallyScrollableBehavior
        }
      }
    },

    initialize: function() {
      this.once('render', this.addRedactor, this);

      UIKit.ItemView.prototype.initialize.apply(this, arguments);
    },

    addRedactor: function() {
      var self = this;
      var isFirstChange = true;
      var ignoreNextRedactorChangeEvent = false;

      this.on('change:value', function(view, value, previousValue, options) {
        if (this.isEventTriggeredExternally(options)
          && this.willRedactorTriggerChangeEvent(value, previousValue, options)) {
          ignoreNextRedactorChangeEvent = true;
        }
      });

     this.ui.textarea.redactor({
        buttons: this.getOption('buttons'),
        plugins: this.getPlugins(),
        focus: this.getOption('focus'),
        air: this.getOption('air'),
        pluginOptions: this.getOption('pluginOptions'),
        paragraphize: false,
        limiter: this.getOption('limiter'),
        minHeight: this.getOption('minHeight'),
        placeholder: this.getOption('placeholder'),
        tabindex: this.getOption('tabindex'),
        tabKey: this.getOption('tabKey'),
        callbacks: {
          init: function() {
            this.code.set(self.getOption('value'));
            self.triggerMethod('redactor:init', this);
          },
          focus: function(e) {
            self.trigger('focus');
          },
          blur: function(e) {
            self.trigger('blur');
          },
          change: function(html) {
            var redactorDidMutateValue = !!(isFirstChange && self.value && !ignoreNextRedactorChangeEvent);
            if (!ignoreNextRedactorChangeEvent) {
              // this event fires in a random tick
              // so the code can be stale compared to the view's value
              // if the view's value is externally changesd before this code runs,
              // then we do not want to update the value with redactor's value
              self._setOption('value', this.code.get(), {
                internal: true,
                eventSource: self,
                silent: redactorDidMutateValue
              });
            }
            ignoreNextRedactorChangeEvent = false;
            isFirstChange = false;
            self.triggerMethod('redactor:change', this);
          }
        }
      });
    },

    isEventTriggeredExternally: function(options) {
      return _.result(options, 'eventSource') !== this;
    },

    willRedactorTriggerChangeEvent: function(value, previousValue) {
      if (jQuery.trim(value) !== jQuery.trim(previousValue)) {
        return true;
      }
      return false;
    },

    focusStart: function() {
      this.ui.textarea.redactor('focus.start');
    },

    getPlugins: function() {
      var plugins = this.getOption('plugins');
      if (!_.isArray(plugins)) {
        plugins = [];
      }
      plugins.push('limiter');
      return plugins;
    },

    updateAttributes: function() {
      var redactorInstance = this.getRedactorInstance();

      if (redactorInstance) {
        redactorInstance.code.set(this.value);
      }

      var $redactorBox = this.$el.find('.redactor-box');
      var $redactorInline = this.$el.find('.redactor-in');

      this.$redactor = ($redactorBox.length > 0)? $redactorBox: $redactorInline;
      this.$redactor.toggleClass('read-only', this.getBoolOption('readonly'));
      this.$redactor.toggleClass('disabled', this.getBoolOption('disabled'));
      this.$redactor.toggleClass('basic', this.getBoolOption('basic'));
      this.$redactor.toggleClass('borderless', this.getBoolOption('borderless'));
      this.$redactor.toggleClass('fitted', this.getBoolOption('fitted'));
    },

    getRedactorInstance: function() {
      if (this.ui.textarea) {
        return this.ui.textarea.data('redactor');
      }
    }
  });

  module.exports = RedactorView;
});

